module.exports = __webpack_public_path__ + "media/images/cookie-46bbb399a0b7a1e6be681299eb8b27dc.svg";